// Display-only cleanup of raw FatSecret food/serving labels. Does NOT change any underlying
// serving data, units, amounts or macros — it only tidies the visible text (strips USDA-style
// qualifiers like "NS as to ...", "NFS", stray "NS", and "yields ..." phrasing).
export function cleanLabel(s) {
  if (!s) return s;
  const out = String(s)
    .replace(/,?\s*ns as to[^,]*/gi, '')   // "avocado, NS as to Florida or California" -> "avocado"
    .replace(/,?\s*\bnfs\b/gi, '')          // "cup, NFS" -> "cup"
    .replace(/,?\s*\bns\b/gi, '')           // stray ", NS"
    .replace(/,?\s*\byields\b.*$/gi, '')    // "oz yields 0.5 cup" -> "oz"
    .replace(/\s{2,}/g, ' ')
    .replace(/\s*,\s*$/, '')
    .trim();
  return out || s;
}

// Measurement ABBREVIATIONS that must NEVER be pluralized (a "2 gs" / "2 ozs" is invalid).
const INVARIANT_UNITS = new Set(['g', 'kg', 'mg', 'oz', 'lb', 'lbs', 'ml', 'l', 'cl', 'dl', 'fl oz', 'floz', 'tbsp', 'tsp']);
const IRREGULAR_PLURAL = { box: 'boxes', pouch: 'pouches', patty: 'patties' };

// DISPLAY-ONLY quantity-aware pluralization for COUNT / container units (container->containers,
// slice->slices, piece->pieces, cup->cups), mirroring FoodConfirm's existing semantics. Measurement
// abbreviations stay unchanged. NEVER mutates the authoritative backend unit string.
export function pluralUnit(unit, qty) {
  const cleaned = cleanLabel(unit);
  if (cleaned == null) return cleaned;
  const key = String(cleaned).toLowerCase().trim();
  if (!key || INVARIANT_UNITS.has(key)) return cleaned;
  const n = Number(qty);
  if (!Number.isFinite(n) || n === 1) return cleaned;   // singular for exactly 1 / unknown qty
  if (key.endsWith('s')) return cleaned;                 // already plural (e.g. "slices")
  if (IRREGULAR_PLURAL[key]) return IRREGULAR_PLURAL[key];
  return cleaned + 's';
}

// "Based on: X" support line: show ONLY when the supporting record is genuinely DIFFERENT from the
// displayed food name. rebuild-v2 sets display_label/record both = semantic_identity, so this returns
// null there (never "rice / Based on: rice"); a legitimately different structured record still returns it.
export function supportRecordFor(displayName, record) {
  if (!record) return null;
  const rec = cleanLabel(record);
  if (!rec || !String(rec).trim()) return null;
  if (String(rec).trim().toLowerCase() === String(displayName || '').trim().toLowerCase()) return null;
  return rec;
}
